import { createApiRef } from '@backstage/frontend-plugin-api';

export type GithubInfoType = {
  latestPullRequest: {
    name: string;
    num: string;
    author: string;
    mergedAt: string;
  };
};

export type AppClusterInfoType = {
  status?: string | undefined;
  name: string;
  lastSyncAt?: string;
  revisions: {
    helm?: string | undefined;
    dockerTag?: string | undefined;
    appVersion?: string | undefined;
    github?: GithubInfoType;
  };
};

export type DeployWorkflowsType = {
  name?: string | undefined;
  version?: string | undefined;
  startedAt?: string | undefined;
  finishedAt?: string | undefined;
  createdAt?: string | undefined;
  author?: string | undefined;
  title?: string | undefined;
  url?: string | undefined;
  kargoUrl?: string | undefined;
  phase?: string | undefined;
  steps?:
    | {
        startedAt?: string | undefined;
        finishedAt?: string | undefined;
        phase?: string | undefined;
        cluster?: string | undefined;
        group?: string | undefined;
      }[]
    | undefined;
};

export type KargoStageType = {
  name: string;
  healthy: boolean;
  isPromoting: boolean;
  promotionStartedAt?: string;
  lastPromotion?: {
    finishedAt?: string;
    succeeded: boolean;
    imageTag?: string;
  };
};

export type App = {
  repo?: string | undefined;
  name: string;
  team: string;
  clusterInfo: Record<string, AppClusterInfoType>;
  runningWorkflows: DeployWorkflowsType[];
  recentDeploys: DeployWorkflowsType[];
  kargoStages?: KargoStageType[];
};

export type AppsResponse = {
  apps: App[];
};

export type Cluster = {
  name: string;
  env: 'prod';
  deploymentType: 'hq' | 'slave' | 'master' | 'other';
};

export type Team = {
  name: string;
};

export type Teams = {
  teams: Team[];
};

export interface DeploymentsApi {
  getApps(params: Record<string, string | undefined>): Promise<AppsResponse>;
  getClusters(): Promise<Cluster[]>;
  getRepositories(): Promise<string[]>;
  getTeams(): Promise<Teams>;
}

export const deploymentsApiRef = createApiRef<DeploymentsApi>().with({
  id: 'plugin.deployments.api',
});
